import { createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH } from '../../constant';
import { getToken } from '../../Utils/authUtils';

export interface Payload {
  email?: string;
  loggedInId?: string;
  hospitalId?: string;
  action: string;
}

export const getUserDocApi = createAsyncThunk('getUserDoc', async (payload: Payload, { rejectWithValue }) => {
  try {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(payload),
    };
    let res = await fetch(AUTH.GET_USER_DOCUMENTS, requestOptions);
    const data = await res.json();

    if (!res.ok) {
        return rejectWithValue(data);
    }

    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
